// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"94c34a09","453":"7fec19d4"}[chunkId] + ".chunk.js";
};